import SelectClients from '../components/Selects/SelectClients';
import Datepicker from '../components/Inputs/Datepicker/Datepicker';
import SelectContainers from '../components/Selects/SelectContainers';

export const dkpSignFilterOptions = [
  { name: 'clientId', component: SelectClients, label: 'ÐÐ»Ð¸ÐµÐ½Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°' },
  { name: 'createdAt', component: Datepicker, label: 'ÐÐ°ÑÐ°', placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³' },
  { name: 'dealId', label: 'Ð¡Ð´ÐµÐ»ÐºÐ°', placeholder: 'ID ÑÐ´ÐµÐ»ÐºÐ¸' },
  { name: 'carId', component: SelectContainers, label: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð°Ð²ÑÐ¾' },
]; 